import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'split' })
export class SplitPipe implements PipeTransform {
  transform(text?: string | null, delim = '\n') {
    return text?.split?.(delim).filter((t) => !!t) || [];
  }
}
